import { Component } from '@angular/core';
import { VersionService } from 'app/services/version.service';

@Component({
    selector: 'app-application-version',
    imports: [],
    templateUrl: './application-version.component.html',
})
export class FooterDisclaimerComponent {
    constructor(private _versionService: VersionService) {
        //
    }

    get applicationVersion(): string {
        return this._versionService.appVersion;
    }
}
